import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Image, Alert } from "antd";
import { getFileChannelSizesWarnings } from "frontend-lib/SizeChecker";
import { ChannelWarningMessages } from "frontend-lib/SizeChecker/types";
import { getFileType } from "Components/ChatHandler/ChatUtils/fileUtils";

type File = {
    name?: string;
    size?: number;
    type?: string;
};
interface props {
    isVisible: boolean;
    previewImageUrl: string;
    attachment: File | null;
    handleModalOkCb: () => void;
    handleModalCancelCb: () => void;
    chatChannel: string;
    originalFileName: string;
}

const getChannelWarnings = (warnings: ChannelWarningMessages, chatChannel: string) => {
    const listWarnings = Object.entries(warnings);
    const channels = listWarnings
        .filter((item) => item[0] === chatChannel.toLocaleLowerCase())
        .filter(([_, warning]) => warning.show);
    return channels;
};

function UploadMediaModal({
    isVisible,
    previewImageUrl,
    attachment,
    handleModalOkCb,
    handleModalCancelCb,
    chatChannel,
    originalFileName
}: props) {
    const { t } = useTranslation();

    let warnings = useMemo(() => {
        if (attachment && attachment.size && attachment.type) {
            const size = attachment && attachment.size ? attachment.size : 0;
            const fileType = getFileType(attachment.type);
            const warnings = getFileChannelSizesWarnings(size, fileType);
            const channelWarnings = getChannelWarnings(warnings, chatChannel);
            return channelWarnings;
        }
    }, [attachment, chatChannel]);

    function renderRenamedText() {
        return (<p style={{ marginTop: "5px" }}>
            <b> {originalFileName}</b> {t('fileUpload.willBeRenamed')}
            <b> {attachment?.name}</b>
        </p>)
    }

    return (
        <Modal
            title={previewImageUrl ? t("fileUpload.sendImage") : t("fileUpload.sendFile")}
            visible={isVisible}
            onOk={handleModalOkCb}
            onCancel={handleModalCancelCb}
        >
            <>
                {previewImageUrl ? (
                    <>
                        <Image src={previewImageUrl} style={{ maxWidth: "100%" }} />
                        {renderRenamedText()}
                    </>
                ) : (
                    <>{renderRenamedText()}</>
                )}
                {warnings && warnings.length ? (
                    <Alert
                        message={t("agentCharExceded", {
                            channel: chatChannel.toLocaleLowerCase(),
                        })}
                        type="warning"
                        showIcon
                        closable
                    />
                ) : null}
            </>
        </Modal>
    );
}

export default UploadMediaModal;
